import { render, staticRenderFns } from "./RoleNameInput.vue?vue&type=template&id=75a80126&"
import script from "./RoleNameInput.vue?vue&type=script&lang=ts&"
export * from "./RoleNameInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports